import { frontendURL } from 'dashboard/helper/URLHelper';
import HorarioUsoIndex from './Index.vue';

export const routes = [
  {
    // Acesso ao sistema por dia (allowlist). Somente super admin id 1 (guard no backend).
    path: frontendURL('accounts/:accountId/horario-de-uso'),
    name: 'horario_uso',
    component: HorarioUsoIndex,
    meta: {
      permissions: ['administrator'],
    },
  },
];

export default { routes };
